import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
function BtnAzkary() {
  return (
    <motion.div
      className="mx-auto mt-4"
      initial={{ x: "-100vw" }}
      animate={{ x: 0 }}
      transition={{ delay: 0.3, duration: 0.8 }}
    >
      <Link
        className="text-center text-decoration-none font-semibold hover:text-black p-4 azkare ms-5  mx-auto"
        to="/azkary"
      >
        اذكاري
      </Link>
    </motion.div>
  );
}

export default BtnAzkary;
